'use client';

import dynamic from 'next/dynamic';
import { useContentfulInspectorMode, useContentfulLiveUpdates } from '@contentful/live-preview/react';
import { TypePageExpertise } from '@fm-nx/contentful-types';
import get from 'lodash.get';
const Nav = dynamic(() => import('../../components/nav'));
const PageIntroLevel2Display = dynamic(
    () => import('@fm-nx/ui').then((mod) => ({ default: mod.PageIntroLevel2Display })),
    {
        ssr: false,
    }
);
const BlockRenderer = dynamic(() => import('@fm-nx/ui').then((mod) => ({ default: mod.BlockRenderer })));

interface ExpertiseDetailProps {
    page: TypePageExpertise<'WITHOUT_UNRESOLVABLE_LINKS'>;
    preview: boolean;
}

export default function ExpertiseDetail({ page, preview }: ExpertiseDetailProps) {
    const inspectorProps = useContentfulInspectorMode();
    const updatedPage = useContentfulLiveUpdates(page);
    const { sections = [] } = updatedPage.fields;

    let tocRaw = get(updatedPage?.fields, 'tableOfContents', []);
    let toc: any[] = Array.isArray(tocRaw) ? tocRaw.filter((item: any) => item?.label && item?.anchor) : [];

    return (
        <div>
            <Nav variant="dark" preview={preview} />
            <PageIntroLevel2Display
                overline="What We Do"
                title={updatedPage?.fields.title || ''}
                headerText={updatedPage?.fields.title || ''}
                headerParagraph={updatedPage?.fields.summary}
                tableOfContents={toc}
                button={{
                    sys: { id: `page-intro-text-${updatedPage?.sys.id}` },
                    __typename: 'Button',
                    buttonText: 'Start a Conversation',
                    linkPath: '#contact',
                }}
                backgroundColor="green-100"
            />
            <BlockRenderer block={sections} suppressFirstBlockTopMargin />
        </div>
    );
}
